import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.components.AvailabilityCreate.title',
    defaultMessage: 'Add availability',
  },
  failureMessage: {
    id: 'app.components.AvailabilityCreate.failureMessage',
    defaultMessage: 'Failed to add availability',
  },
  successMessage: {
    id: 'app.components.AvailabilityCreate.successMessage',
    defaultMessage: 'Successfully added availability',
  },
  back: {
    id: 'app.components.AvailabilityCreate.back',
    defaultMessage: 'Back to my availabilities',
  },
  firstApplicationOnDate: {
    id: 'app.components.AvailabilityCreate.firstApplicationOnDate',
    defaultMessage: 'This availability will be considered starting {date}.',
  },
});
